export default __webpack_public_path__ + "static/media/image-main-2-m@3x.2deef3ee.png";